module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/BIOCHEMISTRY-9d26c4ccae32e978a342d664d8eb9fe9.png";